import _ from 'lodash';

export function paginate(items, pageNumber, pageSize) {
  const startIndex = (pageNumber - 1) * pageSize;
  return _(items).slice(startIndex).take(pageSize).value(); //value() converts lodash wrapper to regular array
  //_.slice(items, startIndex)
  //_.take()
}
